import Vue from "vue";
import { apiRequest } from "./api";

export const myCreditsState = Vue.observable({
  loading: false,
  loaded: false,
  overview: null,
  balancesLoading: false,
  balancesLoaded: false,
  balances: null,
});

export function extractCreditAsset(overview) {
  if (!overview || typeof overview !== "object") {
    return null;
  }
  const asset = overview.asset && typeof overview.asset === "object" ? overview.asset : null;
  if (asset) {
    return asset;
  }
  return {
    asset_code: overview.asset_code || "credits",
    balance:
      overview.total != null
        ? Number(overview.total || 0)
        : overview.balance != null
          ? Number(overview.balance || 0)
          : 0,
    paid: overview.paid != null ? Number(overview.paid || 0) : 0,
    free: overview.free != null ? Number(overview.free || 0) : 0,
    updated_at: overview.updated_at || "",
  };
}

export function extractCreditBalance(overview) {
  const asset = extractCreditAsset(overview);
  return asset ? Number(asset.balance || 0) : 0;
}

export function clearMyCreditsOverview() {
  myCreditsState.loading = false;
  myCreditsState.loaded = false;
  myCreditsState.overview = null;
  myCreditsState.balancesLoading = false;
  myCreditsState.balancesLoaded = false;
  myCreditsState.balances = null;
}

export async function refreshMyCreditsOverview() {
  myCreditsState.loading = true;
  try {
    const payload = await apiRequest("/api/v1/me/credits/balances");
    const overview = payload && payload.balances ? payload.balances : null;
    myCreditsState.overview = overview
      ? {
          ...overview,
          asset: extractCreditAsset(overview),
        }
      : null;
    myCreditsState.loaded = true;
    return myCreditsState.overview;
  } catch (error) {
    clearMyCreditsOverview();
    throw error;
  } finally {
    myCreditsState.loading = false;
  }
}

export async function refreshMyCreditBalances() {
  myCreditsState.balancesLoading = true;
  try {
    const payload = await apiRequest("/api/v1/me/credits/balances");
    myCreditsState.balances = payload && payload.balances ? payload.balances : null;
    myCreditsState.balancesLoaded = true;
    return myCreditsState.balances;
  } catch (error) {
    myCreditsState.balancesLoading = false;
    myCreditsState.balancesLoaded = false;
    myCreditsState.balances = null;
    throw error;
  } finally {
    myCreditsState.balancesLoading = false;
  }
}

export async function fetchMyCreditLedger(params = {}) {
  const search = new URLSearchParams();
  if (params.limit) {
    search.set("limit", String(params.limit));
  }
  if (params.offset) {
    search.set("offset", String(params.offset));
  }
  if (params.cursor) {
    search.set("cursor", String(params.cursor));
  }
  const query = search.toString();
  const payload = await apiRequest(query ? `/api/v1/me/credits/ledger?${query}` : "/api/v1/me/credits/ledger");
  return payload && payload.ledger ? payload.ledger : null;
}
